import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { ProgressBar, Spinner } from "react-bootstrap";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { FaCircleCheck } from "react-icons/fa6";
import EditPackageModal from "../../Components/Modals/EditPackageModal.js";
import { GAME_TYPE } from "../../constants.js";
import { useDeleteServiceMutation } from "../../Data/services/serviceApi.js";
import DetailGameModal from "../../Components/Modals/DetailGameModal.js";
import { useGetAllGamesQuery } from "../../Data/services/gameApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const GameManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const dummyData = [
    {
      id: 78,
      user_id: 34,
      type: 10,
      progress: 0,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:43:30.000Z",
      deletedAt: null,
      name: "SecondSolo Game",
      is_completed: true,
      start_at: "2025-04-21T14:43:00.000Z",
      end_at: null,
      game_categories: [
        {
          id: 211,
          game_id: 78,
          category_id: 7,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:42:47.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Climate",
              ar: "مناخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589709913.png",
            updatedAt: "2025-03-10T06:55:25.000Z",
            deletedAt: null,
          },
        },
        {
          id: 212,
          game_id: 78,
          category_id: 8,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:42:58.000Z",
          deletedAt: null,
          start_at: "2025-04-21T14:42:49.000Z",
          end_at: "2025-04-21T14:42:58.000Z",
          category: {
            name: {
              en: "Music",
              ar: "موسيقى",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
            updatedAt: "2025-03-10T06:56:35.000Z",
            deletedAt: null,
          },
        },
        {
          id: 213,
          game_id: 78,
          category_id: 6,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:42:47.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Fashion",
              ar: "موضة",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
            updatedAt: "2025-03-10T06:53:56.000Z",
            deletedAt: null,
          },
        },
        {
          id: 214,
          game_id: 78,
          category_id: 5,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:42:47.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Date",
              ar: "تاريخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
            updatedAt: "2025-03-10T06:52:30.000Z",
            deletedAt: null,
          },
        },
        {
          id: 215,
          game_id: 78,
          category_id: 4,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:42:47.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 216,
          game_id: 78,
          category_id: 1,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          start_at: "2025-04-21T14:43:00.000Z",
          end_at: "2025-04-21T14:43:11.000Z",
          category: {
            name: {
              en: "Football",
              ar: "كرة القدم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
            updatedAt: "2025-03-10T06:42:18.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 98,
          game_id: 78,
          name: "you",
          score: 360,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 99,
          game_id: 78,
          name: "",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T14:39:13.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 0,
      winner_team: {
        id: 98,
        game_id: 78,
        name: "you",
        score: 360,
        is_banned: false,
        is_powerup: false,
        createdAt: "2025-04-21T14:39:13.000Z",
        updatedAt: "2025-04-21T14:43:11.000Z",
        deletedAt: null,
        is_ban_available: 1,
        is_cheat_available: 1,
        is_powerup_available: 1,
      },
    },
    {
      id: 77,
      user_id: 34,
      type: 20,
      progress: 0,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:39.000Z",
      deletedAt: null,
      name: "Second Team Game",
      is_completed: true,
      start_at: null,
      end_at: null,
      game_categories: [
        {
          id: 205,
          game_id: 77,
          category_id: 5,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:37:35.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Date",
              ar: "تاريخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
            updatedAt: "2025-03-10T06:52:30.000Z",
            deletedAt: null,
          },
        },
        {
          id: 206,
          game_id: 77,
          category_id: 6,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:37:35.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Fashion",
              ar: "موضة",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
            updatedAt: "2025-03-10T06:53:56.000Z",
            deletedAt: null,
          },
        },
        {
          id: 207,
          game_id: 77,
          category_id: 7,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:37:35.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Climate",
              ar: "مناخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589709913.png",
            updatedAt: "2025-03-10T06:55:25.000Z",
            deletedAt: null,
          },
        },
        {
          id: 208,
          game_id: 77,
          category_id: 8,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:37:35.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Music",
              ar: "موسيقى",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
            updatedAt: "2025-03-10T06:56:35.000Z",
            deletedAt: null,
          },
        },
        {
          id: 209,
          game_id: 77,
          category_id: 4,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:37:35.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 210,
          game_id: 77,
          category_id: 9,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:37:35.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Sciences",
              ar: "العلوم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589867693.png",
            updatedAt: "2025-03-10T06:58:04.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 96,
          game_id: 77,
          name: "First Team",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 97,
          game_id: 77,
          name: "Second Team",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T14:37:35.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 0,
      winner_team: {},
    },
    {
      id: 73,
      user_id: 34,
      type: 10,
      progress: 0,
      createdAt: "2025-04-21T10:34:31.000Z",
      updatedAt: "2025-04-21T14:38:55.000Z",
      deletedAt: null,
      name: "First Game",
      is_completed: true,
      start_at: "2025-04-21T14:38:26.000Z",
      end_at: null,
      game_categories: [
        {
          id: 181,
          game_id: 73,
          category_id: 6,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:36:20.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Fashion",
              ar: "موضة",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
            updatedAt: "2025-03-10T06:53:56.000Z",
            deletedAt: null,
          },
        },
        {
          id: 182,
          game_id: 73,
          category_id: 8,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:36:20.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Music",
              ar: "موسيقى",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
            updatedAt: "2025-03-10T06:56:35.000Z",
            deletedAt: null,
          },
        },
        {
          id: 183,
          game_id: 73,
          category_id: 4,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:36:20.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 184,
          game_id: 73,
          category_id: 9,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:36:20.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Sciences",
              ar: "العلوم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589867693.png",
            updatedAt: "2025-03-10T06:58:04.000Z",
            deletedAt: null,
          },
        },
        {
          id: 185,
          game_id: 73,
          category_id: 2,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:38:26.000Z",
          deletedAt: null,
          start_at: "2025-04-21T14:38:26.000Z",
          end_at: null,
          category: {
            name: {
              en: "Game of Thrones",
              ar: "صراع العروش",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589044686.png",
            updatedAt: "2025-03-10T06:44:43.000Z",
            deletedAt: null,
          },
        },
        {
          id: 186,
          game_id: 73,
          category_id: 1,
          user_id: 34,
          is_completed: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:36:20.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Football",
              ar: "كرة القدم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
            updatedAt: "2025-03-10T06:42:18.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 88,
          game_id: 73,
          name: "First Game",
          score: 10,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 89,
          game_id: 73,
          name: "",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T10:34:31.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 0,
      winner_team: {
        id: 88,
        game_id: 73,
        name: "First Game",
        score: 10,
        is_banned: false,
        is_powerup: false,
        createdAt: "2025-04-21T10:34:31.000Z",
        updatedAt: "2025-04-21T14:43:11.000Z",
        deletedAt: null,
        is_ban_available: 1,
        is_cheat_available: 1,
        is_powerup_available: 1,
      },
    },
    {
      id: 72,
      user_id: 34,
      type: 20,
      progress: 5.56,
      createdAt: "2025-04-21T09:21:09.000Z",
      updatedAt: "2025-04-21T11:52:15.000Z",
      deletedAt: null,
      name: "Second Game Team",
      is_completed: true,
      start_at: "2025-04-21T11:52:01.000Z",
      end_at: "2025-04-21T09:26:24.000Z",
      game_categories: [
        {
          id: 175,
          game_id: 72,
          category_id: 6,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T11:52:15.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Fashion",
              ar: "موضة",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
            updatedAt: "2025-03-10T06:53:56.000Z",
            deletedAt: null,
          },
        },
        {
          id: 176,
          game_id: 72,
          category_id: 5,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T11:52:15.000Z",
          deletedAt: null,
          start_at: "2025-04-21T11:52:01.000Z",
          end_at: null,
          category: {
            name: {
              en: "Date",
              ar: "تاريخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
            updatedAt: "2025-03-10T06:52:30.000Z",
            deletedAt: null,
          },
        },
        {
          id: 177,
          game_id: 72,
          category_id: 2,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T11:52:15.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Game of Thrones",
              ar: "صراع العروش",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589044686.png",
            updatedAt: "2025-03-10T06:44:43.000Z",
            deletedAt: null,
          },
        },
        {
          id: 178,
          game_id: 72,
          category_id: 4,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T11:52:15.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 179,
          game_id: 72,
          category_id: 1,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T11:52:15.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Football",
              ar: "كرة القدم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
            updatedAt: "2025-03-10T06:42:18.000Z",
            deletedAt: null,
          },
        },
        {
          id: 180,
          game_id: 72,
          category_id: 8,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T11:52:15.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Music",
              ar: "موسيقى",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
            updatedAt: "2025-03-10T06:56:35.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 86,
          game_id: 72,
          name: "Team 1",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 87,
          game_id: 72,
          name: "Team 2",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T09:21:09.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 2,
      winner_team: {},
    },
    {
      id: 71,
      user_id: 34,
      type: 10,
      progress: 0,
      createdAt: "2025-04-21T09:15:18.000Z",
      updatedAt: "2025-04-21T10:21:57.000Z",
      deletedAt: null,
      name: "First Game",
      is_completed: true,
      start_at: "2025-04-21T10:10:17.000Z",
      end_at: null,
      game_categories: [
        {
          id: 169,
          game_id: 71,
          category_id: 1,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T10:21:57.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Football",
              ar: "كرة القدم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
            updatedAt: "2025-03-10T06:42:18.000Z",
            deletedAt: null,
          },
        },
        {
          id: 170,
          game_id: 71,
          category_id: 2,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T10:21:57.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Game of Thrones",
              ar: "صراع العروش",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589044686.png",
            updatedAt: "2025-03-10T06:44:43.000Z",
            deletedAt: null,
          },
        },
        {
          id: 171,
          game_id: 71,
          category_id: 3,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T10:21:57.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Eater",
              ar: "آكل",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589317924.png",
            updatedAt: "2025-03-10T06:48:50.000Z",
            deletedAt: null,
          },
        },
        {
          id: 172,
          game_id: 71,
          category_id: 4,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T10:21:57.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 173,
          game_id: 71,
          category_id: 5,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T10:21:57.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Date",
              ar: "تاريخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
            updatedAt: "2025-03-10T06:52:30.000Z",
            deletedAt: null,
          },
        },
        {
          id: 174,
          game_id: 71,
          category_id: 8,
          user_id: 34,
          is_completed: true,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T10:21:57.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Music",
              ar: "موسيقى",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
            updatedAt: "2025-03-10T06:56:35.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 84,
          game_id: 71,
          name: "First Game",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 85,
          game_id: 71,
          name: "",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-21T09:15:18.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 0,
      winner_team: {},
    },
    {
      id: 65,
      user_id: 3,
      type: 20,
      progress: 11.11,
      createdAt: "2025-04-11T12:01:59.000Z",
      updatedAt: "2025-04-18T05:28:52.000Z",
      deletedAt: null,
      name: "Kohler - Stiedemann",
      is_completed: true,
      start_at: "2025-04-14T11:07:33.000Z",
      end_at: null,
      game_categories: [
        {
          id: 133,
          game_id: 65,
          category_id: 1,
          user_id: 3,
          is_completed: true,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-14T12:42:41.000Z",
          deletedAt: null,
          start_at: "2025-04-14T11:07:31.000Z",
          end_at: null,
          category: {
            name: {
              en: "Football",
              ar: "كرة القدم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
            updatedAt: "2025-03-10T06:42:18.000Z",
            deletedAt: null,
          },
        },
        {
          id: 134,
          game_id: 65,
          category_id: 2,
          user_id: 3,
          is_completed: true,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-14T12:42:41.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Game of Thrones",
              ar: "صراع العروش",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589044686.png",
            updatedAt: "2025-03-10T06:44:43.000Z",
            deletedAt: null,
          },
        },
        {
          id: 135,
          game_id: 65,
          category_id: 3,
          user_id: 3,
          is_completed: true,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-14T12:42:41.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Eater",
              ar: "آكل",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589317924.png",
            updatedAt: "2025-03-10T06:48:50.000Z",
            deletedAt: null,
          },
        },
        {
          id: 136,
          game_id: 65,
          category_id: 4,
          user_id: 3,
          is_completed: true,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-14T12:42:41.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 137,
          game_id: 65,
          category_id: 5,
          user_id: 3,
          is_completed: true,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-14T12:42:41.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Date",
              ar: "تاريخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
            updatedAt: "2025-03-10T06:52:30.000Z",
            deletedAt: null,
          },
        },
        {
          id: 138,
          game_id: 65,
          category_id: 6,
          user_id: 3,
          is_completed: true,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-14T12:42:41.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Fashion",
              ar: "موضة",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
            updatedAt: "2025-03-10T06:53:56.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 72,
          game_id: 65,
          name: "Kole",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 73,
          game_id: 65,
          name: "Leuschke",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-11T12:02:00.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 4,
      winner_team: {},
    },
    {
      id: 55,
      user_id: 26,
      type: 20,
      progress: 0,
      createdAt: "2025-04-10T14:38:56.000Z",
      updatedAt: "2025-04-21T11:52:04.000Z",
      deletedAt: null,
      name: "Raynor and Sons",
      is_completed: true,
      start_at: "2025-04-14T07:01:30.000Z",
      end_at: null,
      game_categories: [
        {
          id: 73,
          game_id: 55,
          category_id: 1,
          user_id: 26,
          is_completed: true,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T11:52:04.000Z",
          deletedAt: null,
          start_at: "2025-04-14T07:01:30.000Z",
          end_at: null,
          category: {
            name: {
              en: "Football",
              ar: "كرة القدم",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
            updatedAt: "2025-03-10T06:42:18.000Z",
            deletedAt: null,
          },
        },
        {
          id: 74,
          game_id: 55,
          category_id: 2,
          user_id: 26,
          is_completed: true,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T11:52:04.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Game of Thrones",
              ar: "صراع العروش",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589044686.png",
            updatedAt: "2025-03-10T06:44:43.000Z",
            deletedAt: null,
          },
        },
        {
          id: 75,
          game_id: 55,
          category_id: 3,
          user_id: 26,
          is_completed: true,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T11:52:04.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Eater",
              ar: "آكل",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589317924.png",
            updatedAt: "2025-03-10T06:48:50.000Z",
            deletedAt: null,
          },
        },
        {
          id: 76,
          game_id: 55,
          category_id: 4,
          user_id: 26,
          is_completed: true,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T11:52:04.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Medicine",
              ar: "دواء",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
            updatedAt: "2025-03-10T06:51:03.000Z",
            deletedAt: null,
          },
        },
        {
          id: 77,
          game_id: 55,
          category_id: 5,
          user_id: 26,
          is_completed: true,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T11:52:04.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Date",
              ar: "تاريخ",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
            updatedAt: "2025-03-10T06:52:30.000Z",
            deletedAt: null,
          },
        },
        {
          id: 78,
          game_id: 55,
          category_id: 6,
          user_id: 26,
          is_completed: true,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T11:52:04.000Z",
          deletedAt: null,
          start_at: null,
          end_at: null,
          category: {
            name: {
              en: "Fashion",
              ar: "موضة",
            },
            image:
              "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
            updatedAt: "2025-03-10T06:53:56.000Z",
            deletedAt: null,
          },
        },
      ],
      game_teams: [
        {
          id: 52,
          game_id: 55,
          name: "Clarabelle",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
        {
          id: 53,
          game_id: 55,
          name: "Gusikowski",
          score: 0,
          is_banned: false,
          is_powerup: false,
          createdAt: "2025-04-10T14:38:56.000Z",
          updatedAt: "2025-04-21T14:43:11.000Z",
          deletedAt: null,
          is_ban_available: 1,
          is_cheat_available: 1,
          is_powerup_available: 1,
        },
      ],
      total_questions: 36,
      attempted_questions: 0,
      winner_team: {},
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllGamesQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deleteService, { isLoading: isDeleting }] = useDeleteServiceMutation();

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Game Name",
      sort: true,
      align: "left",
      headerStyle: {
        width: "200px",
      },
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        if (row.type === GAME_TYPE.SOLO) {
          return "Solo";
        } else if (row.type === GAME_TYPE.TEAM) {
          return "Team";
        }
      },
    },
    {
      dataField: "progress",
      text: "Progress",
      sort: true,
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return <ProgressBar animated now={row.progress} />;
      },
    },
    {
      dataField: "is_completed",
      text: "Completed",
      sort: true,
      align: "center",
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        if (row) {
          return (
            <FaCircleCheck
              size={20}
              color={row.is_completed ? "green" : "red"}
            />
          );
        }
      },
    },
    {
      dataField: "attempted_questions",
      text: "Attempted Questions",
      sort: true,
      align: "center",
      headerStyle: {
        width: "200px",
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <div
                className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 text-white`}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleEditModalOpen(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center pe-1  `}
                ></span>
                <span>Details</span>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DetailGameModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            // refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Game Management"} classes="text-black" />
        </div>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add Package"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={`${styles.mainTable} `}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                // refetch={refetch} // todo
                refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default GameManagementScreen;
